import React from 'react';
import Dropdown from './popover/Dropdown';
import classNames from 'classnames';

export default function ColorPickerDropdown({
    attachToRef,
    isOpen,
    onClose,
    onSelectColor,
    availableColors,
    selectedColor,
    placeholder,
}: {
    attachToRef: React.RefObject<HTMLElement>;
    isOpen: boolean;
    onClose(): void;
    availableColors: string[];
    selectedColor: string;
    onSelectColor(color: string): void;
    placeholder?: string;
}) {
    return (
        <Dropdown attachToRef={attachToRef} isOpen={isOpen} onClose={onClose}>
            <div className="flex items-center h-[26px] px-2 py-1 font-normal text-xs text-saga-gray-500">
                {placeholder}
            </div>
            <ColorPicker
                availableColors={availableColors}
                selectedColor={selectedColor}
                onSelectColor={onSelectColor}
            />
        </Dropdown>
    );
}

export function ColorPicker({
    availableColors,
    selectedColor,
    onSelectColor,
}: {
    availableColors: string[];
    selectedColor: string;
    onSelectColor(color: string): void;
}) {
    return (
        <div className="flex flex-wrap gap-1">
            {availableColors.map((color) => (
                <div
                    key={color}
                    className={classNames(
                        'w-8 h-8 rounded-md flex items-center justify-center hover:bg-saga-gray-150 dark:hover:bg-saga-gray-800',
                        { 'hover:bg-saga-gray-150 dark:hover:bg-saga-gray-800': color === selectedColor },
                    )}
                    onClick={() => onSelectColor(color)}
                >
                    <div className="w-4 h-4 rounded-full" style={{ backgroundColor: color }} />
                </div>
            ))}
        </div>
    );
}
